/** The nomenclature code seeded by T240. Renaming it here without renaming the seed empties both
 * the adviser's own competence picker and /consilieri's expertise filter — and leaves the coverage
 * report unable to name a single domain, since the response carries ids alone. */
export const ADVISOR_DOMAINS = 'CONSILIERI_DOMENII';
